import {
  DynamicLinkType,
  FlexibleBlockBrickCarousel,
  FlexibleBlockBrickCarouselItem,
  FlexibleBlockBrickCarouselStyle,
  FlexibleBlockProps,
  FlexibleBlockTemplateCarousel,
} from '@nx-frontend/shared/types';
import { getWrapperProps } from '@nx-frontend/shared/utils';
import { brickCommon } from './common';

export const getCarouselBlockTemplate = (): FlexibleBlockProps<FlexibleBlockTemplateCarousel>[] => {
  let slideIndex = -1;
  const items: FlexibleBlockBrickCarouselItem[] = [
    {
      index: ++slideIndex,
      src: '/assets/img/blocks/carousel/slide-1-deliberation.png',
      type: 'image',
      caption: 'Deliberation',
      description: 'Our team will study all your processes and their current results',
      dynamicLink: { type: DynamicLinkType.EXTERNAL, url: 'https://en.wikipedia.org/wiki/Deliberation' },
      button: {
        text: 'More',
      },
    },
    {
      index: ++slideIndex,
      src: '/assets/img/blocks/carousel/slide-2-elaboration.png',
      type: 'image',
      caption: 'Elaboration',
      description: 'We will develop the best possible improvements to your system',
      dynamicLink: { type: DynamicLinkType.EXTERNAL, url: 'https://en.wikipedia.org/wiki/Elaboration' },
      button: {
        text: 'More',
      },
    },
    {
      index: ++slideIndex,
      src: '/assets/img/blocks/carousel/slide-3-presentation.png',
      type: 'image',
      caption: 'Presentation',
      description: 'At the presentation we will explain our solutions and how they will benefit your company',
      dynamicLink: { type: DynamicLinkType.EXTERNAL, url: 'https://en.wikipedia.org/wiki/Presentation' },
      button: {
        text: 'More',
      },
    },
  ];

  const brickCarousel: FlexibleBlockBrickCarousel = {
    ...brickCommon,
    brickType: 'carousel',
    brickName: 'Carousel',
    style: FlexibleBlockBrickCarouselStyle.BASIC,
    showControls: true,
    showIndicators: true,
    items,
  };

  return [
    {
      title: 'Carousel',
      template: {
        type: 'carousel',
        view: 'basic',
      },
      bricks: [{ ...brickCarousel, index: 0 }],
      className: [],
      wrapper: getWrapperProps('bare'),
    },
  ];
};
